import type {
  Appointment,
  Patient,
  Practitioner,
  Reference,
} from '@medplum/fhirtypes'
import { isOfType } from '#src/utils.ts'

export function getPatientReference(
  appointment: Appointment
): Reference<Patient> | undefined {
  return appointment.participant.find((p) => isOfType(p.actor, 'Patient'))
    ?.actor as Reference<Patient> | undefined
}

export function getPractitionerReference(
  appointment: Appointment
): Reference<Practitioner> | undefined {
  return appointment.participant.find((p) => isOfType(p.actor, 'Practitioner'))
    ?.actor as Reference<Practitioner> | undefined
}
